import { render, staticRenderFns } from "./emoji_group.vue.js?vue&type=template&id=3f89425e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_group.vue?vue&type=template&id=3f89425e"
import script from "./emoji_group.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_group.vue?vue&type=script&lang=js"
export * from "./emoji_group.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports